var _baseUrl = process.env.API_ROOT;
var _appurl = process.env.APPUrl

var _httpUrl = process.env.httpUrl;
var _h5url = process.env.h5url


var _domainURL = process.env.DomainURL

var _wxAppId = process.env.WXCard_AppId



export default {

    getAppUrl() {
        return _appurl
    },
    getDomainURL() {
        return _domainURL;
    },
    gethttpUrl(){
        return _httpUrl
    },
    geth5Url(){
        return _h5url
    },
    getWXCardAppId() {
        return _wxAppId;
    },
    getBanners() {
        return _baseUrl + '/Home/GetBanners'
    },
    getHotCity() {
        return _baseUrl + '/Home/GetHotCity'
    },
    getCityByLetter() {
        return _baseUrl + '/Home/GetCityByLetter'
    },
    getOverSeaCityByLetter() {
        return _baseUrl + '/Home/GetOverSeaCity'
    },
    //城市全称
    getCity() {
        return _baseUrl + '/Home/GetCity'
    },
    getLocationListByCityId() {
        return _baseUrl + '/Home/GetLocationListByCityId'
    },
    searchHotelList() {
        return _baseUrl + '/Search/SearchHotelList'
    },
    //判断用户服务端登录状态
    loginState() {
        return _baseUrl + '/Account/LoginState'
    },
    //联合登录 - 获取第三方重定向地址
    CheckOAuth() {
        return _baseUrl + '/UniteLogin/CheckOAuth'
    },
    //联合登录 - 检查第三方信息
    getUnionLoginUrl() {
        return _baseUrl + '/Account/getOAuthUrl'
    },
    //联合登录 - 获取当前登录用户信息
    getUniteUserInfo() {
        return _baseUrl + '/UniteLogin/GetUserInfo'
    },
    //联合登录 - 获取第三方用户名和头像
    getAuthInfo() {
        return _baseUrl + '/UniteLogin/GetAuthInfo'
    },
    //联合登录 - 获取短信验证码
    SendSMS() {
        return _baseUrl + '/UniteLogin/SendSMSCode'
    },
    //联合登录 - 注册和绑定
    RegistAndBind() {
        return _baseUrl + '/UniteLogin/RegistAndBind'
    },
    //联合登录 - 已注册绑定
    Bind() {
        return _baseUrl + '/UniteLogin/Bind'
    },
    // 联合登录 - 获取联动云登录信息
    GetLdygoLoginInfo() {
        return _baseUrl + '/Account/GetLdygoLoginInfo';
    },
    //休闲房 相关接口
    SearchRelaxHotelList() {
        return _baseUrl + '/Search/SearchRelaxHotelList'
    },
    // 休闲房 - 房间列表
    GetRelaxRoomTypeList() {
        return _baseUrl + '/Hotel/GetRelaxRoomTypeList'
    },
    // 休闲房 - 提交订单
    SubmitRelaxHotelOrder() {
        return _baseUrl + '/Hotel/SubmitRelaxHotelOrder'
    },
    // 休闲房 - 获取优惠券
    GetRelaxConpon() {
        return _baseUrl + '/Hotel/GetRelaxConpon'
    },



    //  房型列表
    //获取用户上次签入时间
    getMemberLastCheckInDate() {
        return _baseUrl + '/Hotel/GetMemberLastCheckInDate'
    },
    //获取酒店详情
    getHotelDetail() {
        return _baseUrl + '/Hotel/GetHotelDetail'
    },
    //获取酒店图片
    getHotelImgs() {
        return _baseUrl + '/Hotel/GetHotelImgs'
    },
    //酒店需要预付
    HotelNeedPrePay() {
        return _baseUrl + '/Hotel/HotelNeedPrePay'
    },
    //获取房型列表
    getRoomTypeList() {
        return _baseUrl + '/Hotel/GetRoomTypeList'
    },
    //收藏酒店
    addMyHotel() {
        return _baseUrl + '/UserCenter/AddMyHotel'
    },
    //获取酒店周边
    getHotelSurround() {
        return _baseUrl + '/Hotel/GetHotelSurround'
    },
    getMapHotelDetail() {
        return _baseUrl + '/Hotel/GetMapHotelDetail'
    },
    //用城市名获取城市id
    getCityIDByCityName() {
        return _baseUrl + '/Search/GetCityIDByCityName'
    },
    //获取附近酒店
    searchHotelNearBy() {
        return _baseUrl + '/Search/SearchHotelNearBy'
    },
    //地图预定获取酒店坐标
    searchHotelListForMap() {
        return _baseUrl + '/Search/SearchHotelListForMap'
    },
    //获取订单初始化信息
    initOrder() {
        return _baseUrl + '/Hotel/InitOrder'
    },
    //获取用户可用代金券信息
    GetCouponForOrder() {
        return _baseUrl + '/Hotel/GetCouponForOrder'
    },
    //提交订单
    postOrder() {
        return _baseUrl + '/Hotel/SubmitHotelOrder'
    },
    //非会员提交订单前获取验证码
    getValidateCodeForNoLoginOrder() {
        return _baseUrl + '/Hotel/GetValidateCodeForNoLoginOrder'
    },
    //协议预订之前验证协议编号
    getAgreement() {
        return _baseUrl + '/Hotel/GetAgreement'
    },
    //提交K币换房验证码
    postKCVCode() {
        return _baseUrl + '/Hotel/SubmitHotelOrderWithKCoin'
    },
    //  酒店评论
    GetHotelComment() {
        return _baseUrl + '/Hotel/GetHotelComment'
    },
    //  检查用户评论权限
    GetCheckInRecord() {
        return _baseUrl + '/Hotel/GetCheckInRecord'
    },
    //  提交评论
    SaveComment() {
        return _baseUrl + '/Hotel/SaveComment'
    },
    // 获取常住人员
    GetCheckInList() {
        return _baseUrl + '/UserCenter/GetCheckInList'
    },
    //新增常住人员
    InsertCheckIn() {
        return _baseUrl + '/UserCenter/InsertCheckIn'
    },
    //删除常住人员
    DeleteCheckIn() {
        return _baseUrl + '/UserCenter/DeleteCheckIn'
    },
    //编辑常住人员
    EditCheckIn() {
        return _baseUrl + '/UserCenter/EditCheckIn'
    },
    //会议室预订
    //获取有会议室的酒店
    getMeetRoomHotelList() {
        return _baseUrl + '/MeetRoom/GetMeetRoomHotelList'
    },
    //获取会议室的收费服务
    getExtraCharge() {
        return _baseUrl + '/MeetRoom/GetMeetRoomExtraChargeByHotelCode'
    },
    //获取酒店会议室列表
    getMeetRoom() {
        return _baseUrl + '/MeetRoom/GetMeetRoomByHotelCode'
    },
    //初始化会议室订单
    initMrOrder() {
        return _baseUrl + '/MeetRoom/InitOrder'
    },
    //提交会议室订单
    insertOrder() {
        return _baseUrl + '/MeetRoom/InsertOrder'
    },
    //获取会议室订单
    getMROrderList() {
        return _baseUrl + '/MeetRoom/GetOrderList'
    },
    //获取会议室订单详情
    getMROrderDetail() {
        return _baseUrl + '/MeetRoom/GetOrderDetail'
    },
    //取消会议室订单
    cancelMROrder() {
        return _baseUrl + '/MeetRoom/CancelOrder'
    },
    //删除会议室订单
    deleteMROrder() {
        return _baseUrl + '/MeetRoom/DeleteOrder'
    },
    //  user模块
    SignIn() { // 登录
        return _baseUrl + '/Account/SignIn'
    },

    // 登录后自动返回调用页面
    SignInAutoBack(){
        return _baseUrl + '/Account/SignInAutoBack';
    },
    // 登录后自动返回调用页面
    GOQuickLoginAutoBack(){
        return _baseUrl + '/Account/GOQuickLoginAutoBack';
    },

    GetUserInfo() { // 登录
        return _baseUrl + '/Account/GetUserInfo'
    },
    getValidateCode() { //  图片验证码
        return _baseUrl + '/Account/GetCaptcha?' + new Date().getTime()
        //return _baseUrl + '/Account/getValidateCode'
    },
    getNumValidateCode() { //  图片验证码
        return _baseUrl + '/Account/GetNumCaptcha?' + new Date().getTime()
        //return _baseUrl + '/Account/getValidateCode'
    },
    getSMSLoginCode() { //  获取手机验证码
        return _baseUrl + '/Account/SMSLoginCode'
    },
    GOQuickLogin() { //  快捷登录
        return _baseUrl + '/Account/GOQuickLogin?'
    },
    LogOff() { //  快捷登录
        return _baseUrl + '/Account/LogOff'
    },
    Signature() { //  签到
        return _baseUrl + '/UserCenter/Signature'
    },
    GetRegisterSMSCode() { //  注册 - 获取验证码
        return _baseUrl + '/UserCenter/GetRegisterSMSCode'
    },
    Register() { //  注册 - 注册
        return _baseUrl + '/UserCenter/Register'
    },
    ForgetPasswordForSMS() { //  忘记密码 - 获取手机验证码
        return _baseUrl + '/UserCenter/ForgetPasswordForSMS'
    },
    ForgetPassword() { //  忘记密码 - 
        return _baseUrl + '/UserCenter/ForgetPassword'
    },
    GetSMSForChangeEmail() { //   通过邮箱获取验证码
        return _baseUrl + '/UserCenter/GetSMSForChangeEmail'
    },
    ChangeEmail() { //  修改邮箱
        return _baseUrl + '/UserCenter/ChangeEmail'
    },
    ChangeAll() { //  修改用户信息
        return _baseUrl + '/UserCenter/UpdateProfile'
    },

    SMSChangePhone() { //  修改手机号 - 发送验证码
        return _baseUrl + '/UserCenter/SMSChangePhone'
    },
    ChangePhone() { //  修改手机号 - 执行
        return _baseUrl + '/UserCenter/ChangePhone'
    },
    YdSMSGetGiftCardCode(){
        return _baseUrl + '/Activity/YdSMSGetGiftCardCode'
    },
    getDigitSignCard()
    {
        return _baseUrl + '/Activity/GetDigitSignCard'
    },
    getDigitUnSignCard()
    {
        return _baseUrl + '/Activity/GetDigitUnSignCard'
    },
    getEntityCard()
    {
        return _baseUrl + '/Activity/GetEntityCard'
    },
    getGiftCard()
    {
        return _baseUrl + '/Activity/GetGiftCard'
    },
    getGiftCardInfo()
    {
        return _baseUrl + '/Activity/GetGiftCardInfo'
    },
    //  UserCenter  - 
    getMyHotel() { //  获取收藏的酒店
        return _baseUrl + '/UserCenter/GetMyHotel'
    },
    DeleteMyHotel() { //  删除收藏的酒店
        return _baseUrl + '/UserCenter/DeleteMyHotel'
    },
    GetMyInvoice() { //  获取发票
        return _baseUrl + '/UserCenter/GetMyInvoice'
    },
    DeleteInvoice() { //  删除发票
        return _baseUrl + '/UserCenter/DeleteInvoice'
    },

    // 20171020  GXX修正 发票管理，公司类型多张
    // AddInvoice() { //  新增发票
    //     return _baseUrl + '/UserCenter/AddInvoice'
    // },

    InsertMemberInvoiceInfo() { //  新增发票
        return _baseUrl + '/UserCenter/InsertMemberInvoiceInfo'
    },
    UpdateMemberInvoiceInfo() { //  修改发票
        return _baseUrl + '/UserCenter/UpdateMemberInvoiceInfo'
    },





    GetUpgradeInfo() { //  获取会员卡升级信息
        return _baseUrl + '/UserCenter/GetUpgradeInfo'
    },
    UpgradeCard() { //  升级会员卡操作
        return _baseUrl + '/UserCenter/UpgradeCard'
    },

    // 获取会员卡升级信息
    GetMemberUpgradeListByCardNo() {
        return _baseUrl + '/UserCenter/GetMemberUpgradeListByCardNo'
    },
    // 升级卡的接口
    UpgradeMemberCardKind() {
        return _baseUrl + '/UserCenter/UpgradeMemberCardKind'
    },

    //  order模块
    getOrderList() { // 订单列表
        return _baseUrl + '/Order/GetOrderList'
    },
    getOrderDetail() { // 订单细节
        return _baseUrl + '/Order/GetOrderDetail'
    },
    CancelResv() { // 取消订单
        return _baseUrl + '/Order/CancelResv'
    },
    DeleteResv() { // 删除订单
        return _baseUrl + '/Order/DeleteResv'
    },


    SMSQueryOrder() { // 非会员协议订单获取手机验证码
        return _baseUrl + '/Order/SMSQueryOrder'
    },
    QueryOrderWithoutLogin() { // 非会员协议订单获取订单列表
        return _baseUrl + '/Order/QueryOrderWithoutLogin'
    },




    GetWaitingForPay() { //  订单多少钱
        return _baseUrl + '/PayMent/GetWaitingForPay'
    },

    //  支付
    GetValuePay() { //  获取储值卡支付页面信息
        return _baseUrl + '/PayMent/GetValuePay'
    },
    PayByStoreCard() { //  用储值卡付钱
        return _baseUrl + '/PayMent/PayByStoreCard'
    },
    PayByAlipayHotel() { //  支付宝付钱
        return _baseUrl + '/PayMent/PayByAlipay'
    },

    //    这个 ，之前何旭东已经写了，只是这里放一下。还是调用他的
    // getMyBankCard() {//获取我的银行卡
    //     return _baseUrl + '/UserCenter/GetMyBankCard'
    // },
    // 银行卡信息初始化
    InitOrderUnionPayCreditCard(type) { //    获取已绑定信用卡支付页面信息
        if (type == 'PayMent')
            return _baseUrl + '/PayMent/InitOrderUnionPayCreditCard'
        else if (type == 'Recharge')
            return _baseUrl + '/Recharge/InitOrderUnionPayCreditCard'
    },
    InitOrderUnionPayDebitCard(type) { //    获取借记卡信息
        if (type == 'PayMent')
            return _baseUrl + '/PayMent/InitOrderUnionPayDebitCard'
        else if (type == 'Recharge')
            return _baseUrl + '/Recharge/InitOrderUnionPayDebitCard'
    },

    //      短信验证  直接支付
    GetValidateCodeForCreditPay(type) { //   信用卡 - 获取短信
        if (type == 'PayMent')
            return _baseUrl + '/PayMent/GetValidateCodeForCreditPay'
        else if (type == 'Recharge')
            return _baseUrl + '/Recharge/GetValidateCodeForCreditPay'
    },
    PayByUnionPayCreditCard(type) { //    信用卡 - 付钱
        if (type == 'PayMent')
            return _baseUrl + '/PayMent/PayByUnionPayCreditCard'
        else if (type == 'Recharge')
            return _baseUrl + '/Recharge/PayByUnionPayCreditCard'
    },
    GetValidateCodeForDebitPay(type) { //   借记卡 - 获取短信
        if (type == 'PayMent')
            return _baseUrl + '/PayMent/GetValidateCodeForDebitPay'
        else if (type == 'Recharge')
            return _baseUrl + '/Recharge/GetValidateCodeForDebitPay'
    },
    PayByUnionPayDebitCard(type) { //    借记卡 付钱
        if (type == 'PayMent')
            return _baseUrl + '/PayMent/PayByUnionPayDebitCard'
        else if (type == 'Recharge')
            return _baseUrl + '/Recharge/PayByUnionPayDebitCard'
    },


    // 银联借记卡第一次支付  
    InitNewCardInfo() { //    获取银联借记卡支付相关信息   没用。就回 订单多少钱
        return _baseUrl + '/PayMent/InitNewCardInfo'
    },

    ValidateBankCard(type) { //    验证银行卡号是否正确   这一段只有在第一次的时候才有用    他只能返回是银行卡还是借记卡
        if (type == 'PayMent')
            return _baseUrl + '/PayMent/ValidateBankCard'
        else if (type == 'Recharge')
            return _baseUrl + '/Recharge/ValidateBankCard'
    },

    GetDebitBankName(type) { //    借记卡的银行名字
        if (type == 'PayMent')
            return _baseUrl + '/PayMent/GetDebitBankName'
        else if (type == 'Recharge')
            return _baseUrl + '/Recharge/GetDebitBankName'
    },
    GetCreditBankName(type) { //    信用卡的银行名字
        if (type == 'PayMent')
            return _baseUrl + '/PayMent/GetCreditBankName'
        else if (type == 'Recharge')
            return _baseUrl + '/Recharge/GetCreditBankName'
    },

    GetValidateCodeForBindCard(type) { //    获取短信验证码(借记卡)第一次支付
        if (type == 'PayMent')
            return _baseUrl + '/PayMent/GetValidateCodeForBindCard'
        else if (type == 'Recharge')
            return _baseUrl + '/Recharge/GetValidateCodeForBindCard'
    },
    PayByUnionPayDebitCardFirst(type) { //    使用银联(借记卡)第一次支付
        if (type == 'PayMent')
            return _baseUrl + '/PayMent/PayByUnionPayDebitCardFirst'
        else if (type == 'Recharge')
            return _baseUrl + '/Recharge/PayByUnionPayDebitCardFirst'
    },

    PayByUnionPayCreditCardFirst(type) { //    信用卡第一次
        if (type == 'PayMent')
            return _baseUrl + '/PayMent/PayByUnionPayCreditCardFirst'
        else if (type == 'Recharge')
            return _baseUrl + '/Recharge/PayByUnionPayCreditCardFirst'
    },
    // 他人代付
    GetPayUrl() { //    代付链接
        return _baseUrl + '/PayMent/GetPayUrl'
    },



    // 储值卡支付
    PayByAlipayStore() { //  支付宝付钱
        return _baseUrl + '/Recharge/PayByAlipay'
    },




    //钱包模块
    //获取钱包信息
    GetMyWallet() {
        return _baseUrl + '/UserCenter/GetMyWallet'
    },
    //获取现金券记录
    getCashLog() {
        return _baseUrl + '/UserCenter/GetCashLog'
    },
    //获取K币记录
    getKCoinLog() {
        return _baseUrl + '/UserCenter/GetKCoinLog'
    },

    //  单条删除K币记录
    DeleteCardMoneyDetail() {
        return _baseUrl + '/UserCenter/DeleteCardMoneyDetail'
    },



    //获取代金券记录
    getCouponLog() {
        return _baseUrl + '/UserCenter/GetCouponLog'
    },
    //获取免房券
    getFreeVouchers() {
        return _baseUrl + '/UserCenter/GetFreeVouchers'
    },
    //兑换免房券
    exchangeFreeRoomCoupon() {
        return _baseUrl + '/UserCenter/ExchangeFreeRoomCoupon'
    },
    //判断用户是否开通了储值卡
    hasOpenStoreCard() {
        return _baseUrl + '/UserCenter/HasOpenStoreCard'
    },
    //开通储值卡
    openStoredValueCard() {
        return _baseUrl + '/UserCenter/OpenStoredValueCard'
    },
    //获取储值卡记录
    getStoreCardCashLog() {
        return _baseUrl + '/UserCenter/GetStoreCardCashLog'
    },
    //删除储值卡交易流水记录
    deleteStoreCardCashLog() {
        return _baseUrl + '/UserCenter/DeleteStoreCardCashLog'
    },

    //储值卡充值
    submitRechargeOrder() {
        return _baseUrl + '/UserCenter/SubmitRechargeOrder'
    },
    //获取商城币操作记录
    getMallCoinLog() {
        return _baseUrl + '/UserCenter/GetMallCoinLog'
    },
    //使用代金券码兑换代金券
    exchangeCouponByCouponCode() {
        return _baseUrl + '/UserCenter/ExchangeCouponByCouponCode'
    },
    //使用K币兑换代金券
    exchangeCouponByKCoin() {
        return _baseUrl + '/UserCenter/ExchangeCouponByKCoin'
    },
    //获取短信验证码
    sendSMSCode() {
        return _baseUrl + '/Common/SendSMSCode'
    },
    //修改储值卡支付密码
    resetStoredCardPassword() {
        return _baseUrl + '/UserCenter/ResetStoredCardPassword'
    },
    //获取我的银行卡
    getMyBankCard() {
        return _baseUrl + '/UserCenter/GetMyBankCard'
    },
    //绑定信用卡时获取短信验证码
    getValidateCodeToBindCard() {
        return _baseUrl + '/UserCenter/GetValidateCodeToBindCard'
    },
    //绑定银行卡
    confirmBindingCard() {
        return _baseUrl + '/UserCenter/ConfirmBindingCard'
    },
    //解绑绑定银行卡
    cancelBindCard() {
        return _baseUrl + '/UserCenter/CancelBindCard'
    },
    //获取商城预存款各项可兑换的额度
    getMallCoinCanExchange() {
        return _baseUrl + '/UserCenter/GetMallCoinCanExchange'
    },
    //兑换商城预存款
    exchangeMallCoin() {
        return _baseUrl + '/UserCenter/ExchangeMallCoin'
    },

    //加入格林留言
    joinGreen() {
        return _baseUrl + '/Home/JoinGreen'
    },

    //加入格林
    JoinGreenMessage() {
        return _baseUrl + '/Home/JoinGreenMessage'
    },

    //自助选房 - 获取可用房间
    getUseableRooms() {
        return _baseUrl + '/RoomInfo/GetUseableRooms'
    },

    //自助选房 - 提交选房
    postRoom() {
        return _baseUrl + '/RoomInfo/PostRoom'
    },

    //自助选房 - 获取已选中房间
    getSelectedRoom() {
        return _baseUrl + '/RoomInfo/GetSelectedRoom'
    },



    //第一个红包活动
    GetOpeningAPPRed() {
        return _baseUrl + '/GrabRedPacket/GetOpeningAPPRed'
    },
    GetAppRedBag() {
        return _baseUrl + '/GrabRedPacket/GetAppRedBag'
    },

    //  酒店红包
    GetRedBagInHotel() {
        return _baseUrl + '/RedBagInHotel/GetRedBagInHotel'
    },

    //  注册送红包(在Account控制器里面)
    RegistGiveVoucher() {
        return _baseUrl + '/Account/RegistGiveVoucher'
    },

    // 爱奇艺抽月卡活动
    KBtradedIQY() {
        return _baseUrl + '/Activity/KBtradedIQY'
    },
    // 邀请有礼 - 总邀请数  可抽奖数
    InvitationMyList() {
        return _baseUrl + '/Activity/InvitationMyList'
    },

    // 邀请有礼 - 抽奖
    InvitationLottery() {
        return _baseUrl + '/Activity/InvitationLottery'
    },

    // 邀请有礼 - 自动登录
    CheckAndLogin() {
        return _baseUrl + '/Activity/CheckAndLogin'
    },
    // 邀请有礼 - 登出
    RemoveActivityCardNo() {
        return _baseUrl + '/Activity/RemoveActivityCardNo'
    },
    // 邀请有礼 - 注册
    InvitationRegister() {
        return _baseUrl + '/Activity/InvitationRegister'
    },

    // 店员指导下载APP  计数器接口
    APPDownloadCount() {
        return _baseUrl + '/Activity/APPDownloadCount'
    },

    // 跳入下载页。进入时，酒店编号参数没有的时候，弹出一个提示
    APPDownFirstCheck() {
        return _baseUrl + '/Activity/APPDownFirstCheck'
    },



    // 酒店标签
    GetHotelLabel() {
        return _baseUrl + '/Hotel/GetHotelLabel'
    },
    //微信卡包-登陆跳转
    CheckWeChatOpenId() {
        return _baseUrl + '/WXCardpackage/CheckWeChatLogin'
    },
    //评论 - 获取用户评论数量
    getTopicCount() {
        return _baseUrl + '/Comment/GetTopicCount'
    },
    //评论 - 获取酒店评论列表
    GetHotelTopicAndCount() {
        return _baseUrl + '/Comment/GetHotelTopicAndCount'
    },
    //评论 - 获取酒店评论标签
    GetHotelTopicScoreLabel() {
        return _baseUrl + '/Comment/GetHotelTopicScoreLabel'
    },
    //评论 - 根据分数获取不同的酒店标签
    GetHotelCommentLabelByScore() {
        return _baseUrl + '/Comment/GetHotelCommentLabelByScore'
    },
    //评论 - 插入酒店评论
    InsertHotelTopic() {
        return _baseUrl + '/Comment/InsertHotelTopic'
    },
    //评论 - 获取待评论列表
    GetCommentList() {
        return _baseUrl + '/Comment/GetCommentList'
    },
    //评论 - 插入追评
    InsertTopicAppend() {
        return _baseUrl + '/Comment/AddCommentAppend'
    },
    //评论 - 删除评论
    DeleteTopic() {
        return _baseUrl + '/Comment/DeleteHotelTopic'
    },


    getReservationDrawCount() {
        return _baseUrl + '/Activity/GetReserveDrawCount'
    },

    getLastDrawInfo() {
        return _baseUrl + '/Activity/GetLastDrawInfo'
    },

    reservationRobAwards() {
        return _baseUrl + '/Activity/ReservationRobAwards'
    },

    getDrawList() {
        return _baseUrl + '/Activity/GetDrawHistoryList'
    },

    InitOrderWePay() {
        return _baseUrl + '/WeChat/InitOrderWePay'
    },

    WepayReady() {
        return _baseUrl + '/WeChat/WepayReady'
    },

    // 获取早餐券列表
    GetBreakfastTicketList() {
        return _baseUrl + '/UserCenter/GetBreakfastTicketList'
    },

    Code2D(StrCode) {
        return _baseUrl + '/UserCenter/Code2D?StrCode=' + StrCode
    },


    // 单早双早  根据 酒店，卡号，入住人，时间，获取 - 有没有被赠送早餐
    GetBreakInfo() {
        return _baseUrl + '/Hotel/GetBreakInfo'
    },

    // 打开时获取新闻
    GetNewsFirstPage() {
        return _baseUrl + '/Home/GetNewsFirstPage'
    },


    // 分页 获取新闻
    GetNewsList() {
        return _baseUrl + '/Home/GetNewsList'
    },


    // 新闻详情
    GetNewsDetails() {
        return _baseUrl + '/Home/GetNewsDetails'
    },

    // 活动页面列表
    GetActivityYekCMS() {
        return _baseUrl + '/Home/GetActivityYekCMS'
    },

    /// 获取活动页面的跳转URL
    GetActivityUrl() {
        return _baseUrl + '/Home/GetActivityUrl'
    },

    //微信服务号授权登录
    LoginByWXOpenid() {
        return _baseUrl + '/Account/WXAouthLogin'
    },
    /// 获取酒店服务信息
    GetServiceListByHotelCode() {
        return _baseUrl + '/Hotel/GetServiceListByHotelCode'
    },

    // 获取早餐价格
    GetBreakFastMoneyByHotelCode() {
        return _baseUrl + '/Hotel/GetBreakFastMoneyByHotelCode'
    },


    // 早餐券  下单
    InsertBreakfast() {
        return _baseUrl + '/Hotel/InsertBreakfast'
    },

    // // 取消早餐券订单  【未支付】
    // CancelUnPayedBreakfastReservation(){
    //     return _baseUrl+'/UserCenter/CancelUnPayedBreakfastReservation'
    // },

    // 取消早餐券订单  【已支付】
    CancelBreakfast(val) {
        if (val == "IsPay")
            return _baseUrl + '/UserCenter/CancelBreakfastTicketReservation'
        else
            // // 取消早餐券订单  【未支付】
            return _baseUrl + '/UserCenter/CancelUnPayedBreakfastReservation'
    },



    // KB购买早餐
    GreenCoinExchangeBreakfastTicket() {
        return _baseUrl + '/PayMent/GreenCoinExchangeBreakfastTicket'
    },


    // 黑白名单
    GetIsProhibited() {
        return _baseUrl + '/Hotel/GetIsProhibited'
    },

    // // 2018春节
    // Spring2018CheckLoginAndGetMess() {
    //     return _baseUrl + '/Activity/Spring2018CheckLoginAndGetMess'
    // },

    // // 2018春节
    // Spring2018ChouJiang() {
    //     return _baseUrl + '/Activity/Spring2018ChouJiang'
    // },

    // // 2018春节
    // Spring2018KBBuyTime() {
    //     return _baseUrl + '/Activity/Spring2018KBBuyTime'
    // },

    // // 2018春节
    // InsertSpring2018InvitationPhone() {
    //     return _baseUrl + '/Activity/InsertSpring2018InvitationPhone'
    // },

    // 员工奖励？
    EmployeeReward() {
        return _baseUrl + '/Activity/EmployeeReward'
    },

    // 也是员工奖励，任何人都能领取
    AnyOneReward() {
        return _baseUrl + '/Activity/AnyOneReward'
    },



    // 初始化 现金券 提现 
    InitExtractCash() {
        return _baseUrl + '/UserCenter/InitExtractCash'
    },
    // 执行 现金券 提现 
    DoExtractCash() {
        return _baseUrl + '/UserCenter/DoExtractCash'
    },



    // 外部登陆
    MakeLogin() {
        return _baseUrl + '/Activity/MakeLogin'
    },

    // 获取品牌页里面 PDF
    GetCompanyPDFPath() {
        return _baseUrl + '/Home/GetCompanyPDFPath'
    },
    //微信注册绑定
    WXBindLogin() {
        return _baseUrl + '/Account/WXBindLogin'
    },
    getGeetest() {
        return _baseUrl + '/Captcha/GetCaptcha'
    },
    getGtSMSLoginCode() { //  获取手机验证码
        return _baseUrl + '/Account/GtSMSLoginCode'
    },
    getYdSMSLoginCode() { //  获取手机验证码
        return _baseUrl + '/Account/YdSMSLoginCode'
    },
    getYdSMSLoginCode2() { //  获取手机验证码
        return _baseUrl + '/Account/GetLoginVerifyCode'
    },
    getVerifyImgCode() { //  获取验证类型
        return _baseUrl + '/Account/GetVerifyImgCode'
    },
    //健康值活动服务接口
    getActivityHealthy() { //  获取健康值排名前20位列表
        return _baseUrl + '/ActivityHealthy/GetActivityHealthy'
    },
    submitDrawInfo() {
        return _baseUrl + '/Activity/SubmitReserveDrawInfo'
    },
    getActivityHealthySum() { //  获取会员健康值总和
        return _baseUrl + '/ActivityHealthy/GetActivityHealthySum'
    },

    getActivityHealthyDetail() { //  获取会员健康值详细信息
        return _baseUrl + '/ActivityHealthy/GetActivityHealthyDetail'
    },

    getInsertActivityHealthyDetail() { //  验证手机验证码 并且添加健康值信息
        return _baseUrl + '/ActivityHealthy/InsertHealthyHelpInvitationPhone'
    },

    getActivityHealthyFlag() { // 获取弹框功能信息
        return _baseUrl + '/ActivityHealthy/GetActivityHealthyFlag'
    },

    getCheckLoginInfo() { // 自动登入功能 
        return _baseUrl + '/ActivityHealthy/getCheckLoginInfo'
    },
    getSMSActivityHealthy() { //  健康值活动获取手机验证码
        return _baseUrl + '/ActivityHealthy/SMSLoginCode'
    },

    postCreateCard() { //  会员卡兑换
        return _baseUrl + '/UserCenter/CreateCard'
    },



    // 2018暑期活动 start 
    Summer2018CheckLogin() { //  登录
        return _baseUrl + '/Activity/Summer2018CheckLogin'
    },

    Summer2018ChouJiang() { //  抽奖
        return _baseUrl + '/Activity/Summer2018ChouJiang'
    },

    Summer2018KBBuyTime() { //  购买次数
        return _baseUrl + '/Activity/Summer2018KBBuyTime'
    },

    Summer2018ShowList() { //  展示别人抽中的奖品
        return _baseUrl + '/Activity/Summer2018ShowList'
    },

    GetSummer2018PrizeList() { //  奖品列表
        return _baseUrl + '/Activity/GetSummer2018PrizeList'
    },

    GetSummer2018CardsList() { //  奖品列表
        return _baseUrl + '/Activity/GetSummer2018CardsList'
    },

    GetJsapi() { //  微信功能
        return _baseUrl + '/Activity/GetJsapi'
    },

    GetSignature() { //  奖品列表
        return _baseUrl + '/Activity/GetSignature'
    },

    InsertSummer2018Invi() { //  奖品列表
        return _baseUrl + '/Activity/InsertSummer2018Invi'
    },

    Autumn2018SaveAddress() { //  提交实体奖品的用户住址
        return _baseUrl + '/Activity/Autumn2018SaveAddress'
    },


    // 2018暑期活动 end


    App2018Ristration() { //  奖品列表
        return _baseUrl + '/Activity/App2018Ristration'
    },
    Rist2018SaveAddress() { //  提交实体奖品的用户住址
        return _baseUrl + '/Activity/Rist2018SaveAddress'
    },
    Rist2018GetUserPrize() { //  提交实体奖品的用户住址
        return _baseUrl + '/Activity/Rist2018GetUserPrize'
    },

    //飞常准验证码
    SMSOpenCode() { //  获取健康值排名前20位列表
        return _baseUrl + '/FlyOfterAssociate/SMSOpenCode'
    },
    //飞常准开通
    OpenMemberCard() { //  获取健康值排名前20位列表
        return _baseUrl + '/FlyOfterAssociate/OpenMemberCard'
    },

    WifiPortal() {
        return _baseUrl + '/UserCenter/WifiPortal'
    },
    //手机激活获取验证码
    SMSCode() {
        return _baseUrl + '/Account/SMSCode'
    },
    //手机激活
    ActivateCellPhone() {
        return _baseUrl + '/Account/ActivateCellPhone'
    },








    // 2018  RevolveNum2018CheckLogin
    RevolveNum2018CheckLogin() { //  登录
        return _baseUrl + '/Activity/RevolveNum2018CheckLogin'
    },

    RevolveNum2018ChouJiang() { //  抽奖
        return _baseUrl + '/Activity/RevolveNum2018ChouJiang'
    },

    RevolveNum2018KBBuyTime() { //  购买次数
        return _baseUrl + '/Activity/RevolveNum2018KBBuyTime'
    },

    RevolveNum2018ShowList() { //  展示别人抽中的奖品
        return _baseUrl + '/Activity/RevolveNum2018ShowList'
    },

    GetRevolveNum2018PrizeList() { //  奖品列表
        return _baseUrl + '/Activity/GetRevolveNum2018PrizeList'
    },

    GetRevolveNum2018CardsList() { //  奖品列表
        return _baseUrl + '/Activity/GetRevolveNum2018CardsList'
    },


    InsertRevolveNum2018Invi() { //  奖品列表
        return _baseUrl + '/Activity/InsertRevolveNum2018Invi'
    },


    // 2018周年庆活动 end





    // 2018  华铁 
    HuaTie2018CheckLogin() { //  登录
        return _baseUrl + '/Activity/HuaTie2018CheckLogin'
    },

    HuaTie2018ChouJiang() { //  抽奖
        return _baseUrl + '/Activity/HuaTie2018ChouJiang'
    },

    HuaTie2018ShowList() { //  展示别人抽中的奖品
        return _baseUrl + '/Activity/HuaTie2018ShowList'
    },

    GetHuaTie2018PrizeList() { //  奖品列表
        return _baseUrl + '/Activity/GetHuaTie2018PrizeList'
    },


    // 2018周年庆活动 end


    CodeToInfo() { //  CodeToOpenid
        return _baseUrl + '/Activity/CodeToInfo'
    },




    // 2018暑期活动 start 
    Winter2018CheckLogin() { //  登录
        return _baseUrl + '/Activity/Winter2018CheckLogin'
    },

    Winter2018ChouJiang() { //  抽奖
        return _baseUrl + '/Activity/Winter2018ChouJiang'
    },

    Winter2018KBBuyTime() { //  购买次数
        return _baseUrl + '/Activity/Winter2018KBBuyTime'
    },

    Winter2018ShowList() { //  展示别人抽中的奖品
        return _baseUrl + '/Activity/Winter2018ShowList'
    },

    GetWinter2018PrizeList() { //  奖品列表
        return _baseUrl + '/Activity/GetWinter2018PrizeList'
    },

    GetWinter2018CardsList() { //  奖品列表
        return _baseUrl + '/Activity/GetWinter2018CardsList'
    },

    GetJsapi() { //  微信功能
        return _baseUrl + '/Activity/GetJsapi'
    },

    GetSignature() { //  奖品列表
        return _baseUrl + '/Activity/GetSignature'
    },

    InsertWinter2018Invi() { //  奖品列表
        return _baseUrl + '/Activity/InsertWinter2018Invi'
    },

    Winter2018SaveAddress() { //  提交实体奖品的用户住址
        return _baseUrl + '/Activity/Winter2018SaveAddress'
    },


    // 2018暑期活动 end





    // 2018暑期活动 start 
    Winter2018CheckLogin() { //  登录
        return _baseUrl + '/Activity/Winter2018CheckLogin'
    },

    Winter2018ChouJiang() { //  抽奖
        return _baseUrl + '/Activity/Winter2018ChouJiang'
    },

    Winter2018KBBuyTime() { //  购买次数
        return _baseUrl + '/Activity/Winter2018KBBuyTime'
    },

    Winter2018ShowList() { //  展示别人抽中的奖品
        return _baseUrl + '/Activity/Winter2018ShowList'
    },

    GetWinter2018PrizeList() { //  奖品列表
        return _baseUrl + '/Activity/GetWinter2018PrizeList'
    },

    GetWinter2018CardsList() { //  奖品列表
        return _baseUrl + '/Activity/GetWinter2018CardsList'
    },

    GetJsapi() { //  微信功能
        return _baseUrl + '/Activity/GetJsapi'
    },

    GetSignature() { //  奖品列表
        return _baseUrl + '/Activity/GetSignature'
    },

    InsertA2019SpringInvi() { //  奖品列表
        return _baseUrl + '/Activity/InsertA2019SpringInvi'
    },

    Winter2018SaveAddress() { //  提交实体奖品的用户住址
        return _baseUrl + '/Activity/Winter2018SaveAddress'
    },


    // 2018暑期活动 end



    // 2018暑期活动 start 
    Spring2019CheckLogin() { //  登录
        return _baseUrl + '/Activity/Spring2019CheckLogin'
    },

    Spring2019ChouJiang() { //  抽奖
        return _baseUrl + '/Activity/Spring2019ChouJiang'
    },

    Spring2019KBBuyTime() { //  购买次数
        return _baseUrl + '/Activity/Spring2019KBBuyTime'
    },

    Spring2019ShowList() { //  展示别人抽中的奖品
        return _baseUrl + '/Activity/Spring2019ShowList'
    },

    GetSpring2019PrizeList() { //  奖品列表
        return _baseUrl + '/Activity/GetSpring2019PrizeList'
    },

    GetSpring2019CardsList() { //  奖品列表
        return _baseUrl + '/Activity/GetSpring2019CardsList'
    },

    GetJsapi() { //  微信功能
        return _baseUrl + '/Activity/GetJsapi'
    },

    GetSignature() { //  奖品列表
        return _baseUrl + '/Activity/GetSignature'
    },

    InsertA2019SpringInvi() { //  奖品列表
        return _baseUrl + '/Activity/InsertA2019SpringInvi'
    },

    Spring2019SaveAddress() { //  提交实体奖品的用户住址
        return _baseUrl + '/Activity/Spring2019SaveAddress'
    },

    GetSpring2019PigPower() {
        return _baseUrl + '/Activity/GetSpring2019PigPower'
    },
    GetSpring201FriendsInfo() {
        return _baseUrl + '/Activity/GetSpring201FriendsInfo'
    },
    A2019SpringPowerGift() {
        return _baseUrl + '/Activity/A2019SpringPowerGift'
    },

    // 2018暑期活动 end


    // 2019三四月活动 start 
    March2019CheckLogin() { //  登录
        return _baseUrl + '/Activity/March2019CheckLogin'
    },

    March2019ChouJiang() { //  抽奖
        return _baseUrl + '/Activity/March2019ChouJiang'
    },

    March2019KBBuyTime() { //  购买次数
        return _baseUrl + '/Activity/March2019KBBuyTime'
    },

    March2019ShowList() { //  展示别人抽中的奖品
        return _baseUrl + '/Activity/March2019ShowList'
    },

    GetMarch2019PrizeList() { //  奖品列表
        return _baseUrl + '/Activity/GetMarch2019PrizeList'
    },

    GetMarch2019CardsList() { //  奖品列表
        return _baseUrl + '/Activity/GetMarch2019CardsList'
    },

    GetJsapi() { //  微信功能
        return _baseUrl + '/Activity/GetJsapi'
    },

    GetSignature() { //  奖品列表
        return _baseUrl + '/Activity/GetSignature'
    },

    InsertA2019MarchInvi() { //  奖品列表
        return _baseUrl + '/Activity/InsertA2019MarchInvi'
    },

    March2019SaveAddress() { //  提交实体奖品的用户住址
        return _baseUrl + '/Activity/March2019SaveAddress'
    },

    GetMarch2019PigPower() {
        return _baseUrl + '/Activity/GetMarch2019PigPower'
    },
    GetMarch201FriendsInfo() {
        return _baseUrl + '/Activity/GetMarch201FriendsInfo'
    },
    A2019MarchPowerGift() {
        return _baseUrl + '/Activity/A2019MarchPowerGift'
    },

    A2019MarchUpdateBoxTag() {
        return _baseUrl + '/Activity/A2019MarchUpdateBoxTag'
    },

    A2019MarchChouBox() {
        return _baseUrl + '/Activity/A2019MarchChouBox'
    },
    A2019MarchFreshData() {
        return _baseUrl + '/Activity/A2019MarchFreshData'
    },


    // 集团活动 begin

    // 轮播条
    GetOtherPrizeTurnShow(){
        return _baseUrl + '/Activity/GetOtherPrizeTurnShow';
    },
    // 我的奖品
    GetMyPrize(){
        return _baseUrl + '/Activity/GetMyPrize';
    },
    // 集团活动 end
    // 四月集团活动 begin

    April2019GetUserActivityInfo() {
        return _baseUrl + '/Activity/April2019GetUserActivityInfo';
    },
    April2019OpenSilkBag(){
        return _baseUrl + '/Activity/April2019OpenSilkBag';
    },
    April2019OpenSilkBag(){
        return _baseUrl + '/Activity/April2019OpenSilkBag';
    },
    GetMyEnergyWaterDetail(){
        return _baseUrl + '/Activity/GetMyEnergyWaterDetail';
    },
    GetGreenGarden() {
        // 四月集团活动
        // return _baseUrl + '/Activity/GetGreenGarden';
        // 七月集团活动
        return _baseUrl + '/Activity/GetGreenGardenNew';
    },
    OpenOneLevelPrize() {
        return _baseUrl + '/Activity/OpenOneLevelPrize';
    },
    OpenSecondLevelPrize() {
        return _baseUrl + '/Activity/OpenSecondLevelPrize';
    },
    OpenThirdLevelPrize() {
        return _baseUrl + '/Activity/OpenThirdLevelPrize';
    },
    ActivityQuickVerification() {
        return _baseUrl + '/Activity/ActivityQuickVerification';
    },
    SaveUserWinPrizeInfo(){
        return _baseUrl + '/Activity/SaveUserWinPrizeInfo';
    },
    April2019KBBuyTime(){
        return _baseUrl + '/Activity/April2019KBBuyTime';
    },

    // 北理工校友领会员卡
    CreateMemberNum(){
        return _baseUrl + '/Activity/CreateMemberNum';
    },
    CreateMemberNumResult(){
        return _baseUrl + '/Activity/CreateMemberNumResult';
    },

    // 家有好面抽奖
    GetHaomianPrize(){
        return _baseUrl + '/Activity/GetHaomianPrize';
    },
    SaveUserOrderInfo(){
        return _baseUrl + '/Activity/SaveUserOrderInfo';
    },
    GetMyPrizePage(){
        return _baseUrl + '/Activity/GetMyPrizePage';
    },

    // 2019  RevolveNum2019CheckLogin
    RevolveNum2019CheckLogin() { //  进入抽奖页
        return _baseUrl + '/Activity/GetUserActivityInfo'
    },
    RevolveNum2019ChouJiang() { //  开始抽奖
        return _baseUrl + '/Activity/OpenDrawPrize'
    },
    RevolveNum2019KBBuyTime() { //  购买次数
        return _baseUrl + '/Activity/BuyTimeByKMoney'
    },
    RevolveNum2019InviteRegister(){//  邀请注册
        return _baseUrl + '/Activity/ActivityQuickVerificationSummary'
    },
    GetRevolveNum2019PrizeList() { //  奖品列表
        return _baseUrl + '/Activity/GetMyPrize'
    },
    RevolveNum2019SaveInfo() { //  保存领奖信息
        return _baseUrl + '/Activity/SaveUserWinPrizeInfo'
    },
    // 领取体验卡
    ReceiveExperienceCard(){
        return _baseUrl + '/Activity/ReceiveExperienceCard'
    },

    // 联合登录-手机号 TODO:预留待完善
    UnionLogin(){
        return _baseUrl + '/Account/UnionLogin';
    },
    // 联合登录-三方信息
    BothSidesLogin(){
        return _baseUrl + '/Account/BothSidesLogin';
    },
    // Coupon 领取优惠券  大娘水饺领取优惠券
    GetCoupon(){
        return _baseUrl + '/Activity/GetCoupon';
    },

    // 七月集团活动 - 加载首页数据
    July2019GetUserActivityInfo(){
        return _baseUrl + '/Activity/July2019GetUserActivityInfo';
    },
    // 七月集团活动 - 首页抽奖
    DrawPrize(){
        return _baseUrl + '/Activity/DrawPrize';
    },

    // 九月集团活动 - 加载首页数据
    Setp2019GetUserActivityInfo(){
        return _baseUrl + '/Activity/Setp2019GetUserActivityInfo';
    },
    // 九月集团活动 - 首页抽奖
    Setp2019DrawPrize(){
        return _baseUrl + '/Activity/Setp2019DrawPrize';
    },
    // 九月集团活动 - 开福袋
    Setp2019DrawPrizeSpecial(){
        return _baseUrl + '/Activity/Setp2019DrawPrizeSpecial';
    },
    // 九月集团活动 - 丰收排行榜
    GetNumberInfo(){
        return _baseUrl + '/Activity/GetNumberInfo';
    },

    // 中秋活动  - 首页加载数据
    GetMidAutumn2019UserInfo(){
        return _baseUrl + '/Activity/GetMidAutumn2019UserInfo';
    },

    // 国庆活动 - 抽奖
    DrawNationalDayPrize(){
        return _baseUrl + '/Activity/DrawNationalDayPrize';
    },

    // 用户参与活动信息   -   通用接口  （参数：activityID,userId,sign）
    GetUserActivitySummary(){
        return _baseUrl + '/Activity/GetUserActivitySummary';
    },
    // 抽随机奖   -   通用接口  (参数：activityID,SilkBagID,userCode,sign  备注：等级奖限制的配置)
    DrawPrizeBySilkBagSummary(){
        return _baseUrl + '/Activity/DrawPrizeBySilkBagSummary';
    },

    // 抽随机奖   -   通用接口 
    DrawPrizeBySilkBag(){
        return _baseUrl + '/Activity/DrawPrizeBySilkBag';
    },
    // 获取活动ID   - 通用
    GetActivityID(){
        return _baseUrl + '/Activity/GetActivityIDBylikeName';
    },
    // 分享页面通用接口
    ActivityQuickVerificationCommon(){
        return _baseUrl + '/Activity/ActivityQuickVerificationCommon';
    },

    // 千家万户 注册接口
    GetQWRegister(){
        return _baseUrl + '/Activity/GetQWRegister';
    },

    // 十二月集团活动
    GetHaoPrize(){
        return _baseUrl + '/Activity/GetHaoPrize';
    },

    // 签到测试
    SignInfo(){
        return _baseUrl + '/Activity/SignInfo';
    },

    // 查询欧气卡总数
    GetMyAllCardNum(){
        return _baseUrl + '/Activity/GetMyAllCardNum';
    },

    // 欧气卡任务信息
    GetUserTasks(){
        return _baseUrl + '/Activity/GetUserTasks';
    },

    // 领取连续登录礼包
    GetSignInBag(){
        return _baseUrl + '/Activity/GetSignInBag';
    },

    // 用K币兑换欧气卡
    GetOCardByKMoney(){
        return _baseUrl + '/Activity/GetOCardByKMoney';
    },

    // 秒杀998K币 
    SeckillPrize(){
        return _baseUrl + '/Activity/SeckillPrize';
    },

    // 领取代金券 
    GetCouponPrize(){
        return _baseUrl + '/Activity/GetCouponPrize';
    },

    // 判断奖品是否可以领取 
    GetPrizeShowStatus(){
        return _baseUrl + '/Activity/GetPrizeShowStatus';
    },

    // 欧气卡兑换实物 
    SaveExchangeEnergyWater(){
        return _baseUrl + '/Activity/SaveExchangeEnergyWater';
    },

    //实物中奖用户
    GetRealGoodsPrizeUser(){
        return _baseUrl + '/Activity/GetRealGoodsPrizeUser';
    },

    //春节活动邀请登录
    QuickVerificationFokas(){
        return _baseUrl + '/Activity/QuickVerificationFokas';
    },
    CheckLoginState() {
        return _baseUrl + '/Activity/CheckLoginState';
    },


    // 京东支付接口
    JdpayH() {
        return _baseUrl + '/Jdpay/PayByJDHtml';
    },

    
    // 获取酒店信息 拆分掉异步方法
    GetRoomTypeDetailList() {
        return _baseUrl + '/Hotel/GetRoomTypeDetailList';
    },

       // 云闪付支付接口
    Cloudpay() {
        return _baseUrl + '/CloudPay/PayByCloudHtml';
    },

    //云闪付联合登录
    GetUnionPayBindPhone(host){
        // window.location.host
        return   host == 'i.998.com' ? 'https://upapp.998.com/Login/UnionPayBindPhone' : 'https://miniprotest.greentree.cn/UmsApi/Login/UnionPayBindPhone';
        // return 'https://miniprotest.greentree.cn/UmsApi/Login/UnionPayBindPhone';
    },

}


// WEBPACK FOOTER //
// ./src/api/index.js